import script from "./ViewDateHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDateHandler.vue?vue&type=script&setup=true&lang=js"

import "./ViewDateHandler.vue?vue&type=style&index=0&id=beb0a548&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beb0a548"]])

export default __exports__